import React from "react";
import ReactDOM from "react-dom/client";
import "./style.css";

import { AppThemeProvider, AppMessageProvider } from "@repo/ui";
import { RouterProvider } from "react-router";
import { QueryProvider, router } from "./context";

const App = () => (
    <AppThemeProvider mode="light" density="normal">
        <AppMessageProvider>
            <RouterProvider router={router} />
        </AppMessageProvider>
    </AppThemeProvider>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <QueryProvider>
            <App />
        </QueryProvider>
    </React.StrictMode>,
);
